export const BUTTON_UPLOAD = "BUTTON_UPLOAD";
export const BUTTON_LABEL = "BUTTON_LABEL";
